module.exports = __webpack_public_path__ + "static/img/datu.png@2x.4e08875b.png";